import {
  getAdjacentOoCaseSidebarItemId,
  getOoCaseSidebarNavigationLabel,
} from '@components/CaseSidebar/navigation/ooCaseSidebarNavigation';
import { getVisibleOoCaseSidebarItemIds, resolveOoSectionTitleKey } from '@components/CaseSidebar/buildOoCaseSidebar';
import { resolveOoCaseSidebarItemId } from '@components/CaseSidebar/navigation/ooFormSectionMapping';
import { CaseSidebarItemId } from '@components/CaseSidebar/types';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { OO_CREATE_INDIVIDUAL_SEARCH_PARAM } from './Applicants/CaseApplicantsList';
import type { OoFormRoute, OoFormRouteContext } from './types';

export function useOoFormMappedRoutes(context: OoFormRouteContext): OoFormRoute {
  const { formatMessage } = useIntl();
  const [searchParams] = useSearchParams();
  const formSectionParam = searchParams.get('section');
  const isNestedRoute =
    Boolean(searchParams.get('individualId')) || searchParams.get(OO_CREATE_INDIVIDUAL_SEARCH_PARAM) === '1';
  const visibleSectionIds = getVisibleOoCaseSidebarItemIds(context.sidebarContext);
  const currentSection =
    resolveOoCaseSidebarItemId(formSectionParam, context.sidebarContext) ??
    visibleSectionIds[0] ??
    CaseSidebarItemId.OVERVIEW;

  const useCaseSidebarStepNavigation = Boolean(formSectionParam) && !isNestedRoute;

  const previousSection = useCaseSidebarStepNavigation
    ? getAdjacentOoCaseSidebarItemId(formSectionParam ?? '', context.sidebarContext, 'previous')
    : undefined;

  const nextSection = useCaseSidebarStepNavigation
    ? getAdjacentOoCaseSidebarItemId(formSectionParam ?? '', context.sidebarContext, 'next')
    : undefined;

  const previousLabel = useCaseSidebarStepNavigation
    ? getOoCaseSidebarNavigationLabel(formatMessage, formSectionParam ?? '', context.sidebarContext, 'previous')
    : undefined;

  const nextLabel = useCaseSidebarStepNavigation
    ? getOoCaseSidebarNavigationLabel(formatMessage, formSectionParam ?? '', context.sidebarContext, 'next')
    : undefined;

  return {
    currentSection,
    sectionTitleKey: resolveOoSectionTitleKey(currentSection),
    previousSection,
    nextSection,
    previousLabel,
    nextLabel,
  };
}
